import { FC } from 'react';

interface BasicButtonProps {
  label: string;
  fullWidth?: boolean;
  template?: string;
  isSubmitButton?: boolean;
  fullRounded?: boolean;
  className?: string;
  onClick?: () => void;
}

export const BasicButton: FC<BasicButtonProps> = ({
  className,
  label,
  fullWidth,
  template = 'green',
  isSubmitButton = false,
  fullRounded,
  onClick,
}) => {
  return (
    <>
      <button
        type={isSubmitButton ? 'submit' : 'button'}
        className={`border-green-primary mt-8 border py-2 font-semibold duration-150 ${className} ${template === 'green' && 'bg-green-primary hover:border-green-secondary hover:bg-green-secondary text-white'} ${template === 'white' && 'hover:bg-green-light-primary bg-white'} ${template === 'orange' && 'bg-orange-primary border-2 border-transparent text-white'} ${template === 'orangeOutline' && 'border-orange-primary text-orange-primary border-2 bg-white'} ${fullWidth ? 'w-full' : 'px-5'} ${fullRounded ? 'rounded-full' : 'rounded-lg'} `}
        onClick={onClick}
      >
        {label}
      </button>
    </>
  );
};

interface DashboardButtonProps {
  type: string;
  onClick?: () => void;
}

export const DashboardButton: FC<DashboardButtonProps> = ({ type, onClick }) => {
  return (
    <>
      <button
        type={type === 'confirm' ? 'submit' : 'button'}
        className={`ml-3 rounded-full px-5 py-2 font-semibold ${type === 'confirm' && 'bg-orange-primary text-white'} ${type === 'cancel' && 'border-orange-primary text-orange-primary border-2'} `}
        onClick={onClick}
      >
        {type === 'confirm' && 'Confirmer'}
        {type === 'cancel' && 'Annuler'}
      </button>
    </>
  );
};
